export function someGetter(state) {
}

